// extracted by mini-css-extract-plugin
module.exports = {"main":"drSupport_main__23wFd","follow_ok_box":"drSupport_follow_ok_box__1W0se","follow_btn":"drSupport_follow_btn__1TFQs"};